import { ProcessConfig, StateNode } from '../types';

export function handleEanSave(options: ProcessConfig): StateNode {
  return {
    invoke: {
      src: 'updateEanService',
      onDone: {
        actions: ['updateEanInTransaction', 'save', 'notifySuccess'],
        target: 'itemCounter',
      },
      onError: {
        actions: ['notifyError'],
        target: 'itemCounter',
      },
    },
  };
}
